import React from 'react';

export function CheckmarkIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
    return (
        <svg
            aria-hidden
            width='21'
            height='16'
            viewBox='0 0 21 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            color='#FFFFFF'
            {...props}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19.3631 1.20883C20.07 1.73902 20.2133 2.74189 19.6831 3.44881L10.0832 16.2487C9.8127 16.6094 9.40263 16.8392 8.95383 16.8816C8.50504 16.9241 8.05916 16.7752 7.72586 16.4717L1.3259 10.6431C0.672583 10.0482 0.625295 9.0362 1.22028 8.38288C1.81527 7.72956 2.82722 7.68227 3.48054 8.27726L8.57922 12.9207L17.1231 1.52882C17.6533 0.821903 18.6562 0.678635 19.3631 1.20883Z'
                fill='currentColor'
            />
        </svg>
    );
}
